exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".polycanvas{text-align:left}.canvaswrap{position:relative}.canvas{overflow:visible;border:1px solid rgba(0,0,0,.5);box-shadow:2px 2px 5px -2px rgba(0,0,0,.6);width:400px;height:400px}.result{font-size:.8rem;max-width:calc(400px - 2em)}.not-loading{opacity:0}.loading{opacity:1;transition:opacity 1.5s ease .75s;position:absolute;width:100%;top:200px;font-size:2rem;text-align:center;z-index:999;text-shadow:1px 1px 3px hsla(0,0%,59%,.75)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-cf04585e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PolyCanvas.vue
// module id = 44
// module chunks = 0